import { Injectable, inject } from '@angular/core'
import { Store, Action } from '@ngrx/store'

import { GbBaseFacade } from 'libs/shared/data-access-core/src/lib/+state/gb-base-facade-interface'
import * as BaseEventTicketsSelectors from './base-event-tickets.selectors'
import { EventTicketsState } from './base-event-tickets.reducer'

@Injectable({
  providedIn: 'root',
})
export class BaseEventTicketsFacade implements GbBaseFacade {
  loaded$ = this.store.select(BaseEventTicketsSelectors.selectEventTicketsLoaded)
  allEventTickets$ = this.store.select(BaseEventTicketsSelectors.selectAllEventTickets)
  listLoadedEventTickets$ = this.store.select(BaseEventTicketsSelectors.selectAllListLoadedEventTickets)
  count$ = this.store.select(BaseEventTicketsSelectors.selectCount)
  selectedEventTicket$ = this.store.select(BaseEventTicketsSelectors.selectedEventTicket)
  summary$ = this.store.select(BaseEventTicketsSelectors.selectSummary)
  limit$ = this.store.select(BaseEventTicketsSelectors.selectLimit)
  offset$ = this.store.select(BaseEventTicketsSelectors.selectOffset)
  filters$ = this.store.select(BaseEventTicketsSelectors.selectFilters)
  selectedEventTicketCustomFields$ = this.store.select(BaseEventTicketsSelectors.selectedEventTicketCustomFields)
  selectedEventTicketCustomValues$ = this.store.select(BaseEventTicketsSelectors.selectedEventTicketCustomValues)
  selectEventTicketById$ = (id: string) => this.store.select(BaseEventTicketsSelectors.selectEventTicketById(id))

  constructor(protected store: Store<EventTicketsState>) {}

  dispatch(action: Action): void {
    this.store.dispatch(action)
  }
}
